// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/color.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/color.proto.
 */
export const file_api_proto_v1_color: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * カラーシミュレーションで扱う色メーカー情報
 *
 * @generated from message api_proto.v1.ColorManufacturer
 */
export type ColorManufacturer = Message<"api_proto.v1.ColorManufacturer"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * メーカー名（例: 日塗工）
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 表示順
   *
   * @generated from field: int32 display_order = 3;
   */
  displayOrder: number;
};

/**
 * Describes the message api_proto.v1.ColorManufacturer.
 * Use `create(ColorManufacturerSchema)` to create a new message.
 */
export const ColorManufacturerSchema: GenMessage<ColorManufacturer> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 0);

/**
 * カラーシミュレーションで扱う色のマスター情報
 *
 * @generated from message api_proto.v1.Color
 */
export type Color = Message<"api_proto.v1.Color"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 色コード（例: N-95）。UIで label 兼用
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * 色の表示名
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 16進カラー（例: #F5F7F2）
   *
   * @generated from field: string hex = 4;
   */
  hex: string;

  /**
   * @generated from field: int32 r = 5;
   */
  r: number;

  /**
   * @generated from field: int32 g = 6;
   */
  g: number;

  /**
   * @generated from field: int32 b = 7;
   */
  b: number;

  /**
   * メーカー名（後方互換のため保持）
   *
   * @generated from field: string manufacturer = 8;
   */
  manufacturer: string;

  /**
   * メーカーID
   *
   * @generated from field: int64 manufacturer_id = 12;
   */
  manufacturerId: bigint;

  /**
   * カラートーン
   *
   * @generated from field: api_proto.v1.ColorTone tone = 13;
   */
  tone: ColorTone;
};

/**
 * Describes the message api_proto.v1.Color.
 * Use `create(ColorSchema)` to create a new message.
 */
export const ColorSchema: GenMessage<Color> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 1);

/**
 * 企業の色カタログ 1 エントリ（is_new = 過去7日以内に登録された色）
 *
 * @generated from message api_proto.v1.CompanyColorEntry
 */
export type CompanyColorEntry = Message<"api_proto.v1.CompanyColorEntry"> & {
  /**
   * @generated from field: api_proto.v1.Color color = 1;
   */
  color?: Color;

  /**
   * colors.created が過去7日以内（サーバー判定・全AIカラーユーザー共通）
   *
   * @generated from field: bool is_new = 2;
   */
  isNew: boolean;
};

/**
 * Describes the message api_proto.v1.CompanyColorEntry.
 * Use `create(CompanyColorEntrySchema)` to create a new message.
 */
export const CompanyColorEntrySchema: GenMessage<CompanyColorEntry> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 2);

/**
 * 企業カラーシミュレーション プリセット（1:N の名前付きプリセット）
 *
 * @generated from message api_proto.v1.AiColorPreset
 */
export type AiColorPreset = Message<"api_proto.v1.AiColorPreset"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * display_order 昇順で返す
   *
   * @generated from field: repeated api_proto.v1.AiColorPresetColor colors = 3;
   */
  colors: AiColorPresetColor[];
};

/**
 * Describes the message api_proto.v1.AiColorPreset.
 * Use `create(AiColorPresetSchema)` to create a new message.
 */
export const AiColorPresetSchema: GenMessage<AiColorPreset> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 3);

/**
 * プリセット内の色エントリ（並び順付き）
 *
 * @generated from message api_proto.v1.AiColorPresetColor
 */
export type AiColorPresetColor = Message<"api_proto.v1.AiColorPresetColor"> & {
  /**
   * @generated from field: int64 color_id = 1;
   */
  colorId: bigint;

  /**
   * @generated from field: int32 display_order = 2;
   */
  displayOrder: number;
};

/**
 * Describes the message api_proto.v1.AiColorPresetColor.
 * Use `create(AiColorPresetColorSchema)` to create a new message.
 */
export const AiColorPresetColorSchema: GenMessage<AiColorPresetColor> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 4);

/**
 * ベースエリアのデフォルトプリセット割当
 *
 * @generated from message api_proto.v1.BaseAreaPresetDefault
 */
export type BaseAreaPresetDefault = Message<"api_proto.v1.BaseAreaPresetDefault"> & {
  /**
   * canonical 英語名: "outer wall and balcony" / "roof, ridge" / "gutter" / "fascia, barge"
   *
   * @generated from field: string base_area = 1;
   */
  baseArea: string;

  /**
   * ai_color_presets.id (ULID)
   *
   * @generated from field: string preset_id = 2;
   */
  presetId: string;
};

/**
 * Describes the message api_proto.v1.BaseAreaPresetDefault.
 * Use `create(BaseAreaPresetDefaultSchema)` to create a new message.
 */
export const BaseAreaPresetDefaultSchema: GenMessage<BaseAreaPresetDefault> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 5);

/**
 * 施主向け共有リンクでエリアごとに解決された色一覧
 *
 * @generated from message api_proto.v1.SharedAreaColors
 */
export type SharedAreaColors = Message<"api_proto.v1.SharedAreaColors"> & {
  /**
   * ベースエリアは canonical 英語名（例 "outer wall and balcony"）。
   * カスタムエリアは "<base_image_id>:<sub_areas index>" 形式（例 "1234:0"）。
   * 旧形式（index 単独）は外観カット（元画像）間でキーが衝突するため廃止した。
   *
   * @generated from field: string area_key = 1;
   */
  areaKey: string;

  /**
   * @generated from field: bool is_base_area = 2;
   */
  isBaseArea: boolean;

  /**
   * サーバがプリセット+履歴色を解決済み
   *
   * @generated from field: repeated api_proto.v1.Color colors = 3;
   */
  colors: Color[];
};

/**
 * Describes the message api_proto.v1.SharedAreaColors.
 * Use `create(SharedAreaColorsSchema)` to create a new message.
 */
export const SharedAreaColorsSchema: GenMessage<SharedAreaColors> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 6);

/**
 * 外観カット（base_color_simulation_image_id IS NULL の元画像）単位の施主編集スコープ。
 * 施主が色を変更できるのは「企業側で色変更済みのエリア」だけであり、これはカット単位で決まる。
 *
 * @generated from message api_proto.v1.SharedCutAreaScope
 */
export type SharedCutAreaScope = Message<"api_proto.v1.SharedCutAreaScope"> & {
  /**
   * 外観カット（元画像）の ID
   *
   * @generated from field: int64 base_image_id = 1;
   */
  baseImageId: bigint;

  /**
   * 施主が色変更できるベースエリア（canonical 英語名）。企業側シミュレーション画像で色が入っているエリアのみ
   *
   * @generated from field: repeated string editable_base_areas = 2;
   */
  editableBaseAreas: string[];

  /**
   * このカットのカスタムエリアキー（"<base_image_id>:<index>"）。SharedAreaColors.area_key と対応
   *
   * @generated from field: repeated string custom_area_keys = 3;
   */
  customAreaKeys: string[];
};

/**
 * Describes the message api_proto.v1.SharedCutAreaScope.
 * Use `create(SharedCutAreaScopeSchema)` to create a new message.
 */
export const SharedCutAreaScopeSchema: GenMessage<SharedCutAreaScope> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 7);

/**
 * 共有リンク作成時に指定するエリア別プリセット選択
 *
 * @generated from message api_proto.v1.AreaPresetSelection
 */
export type AreaPresetSelection = Message<"api_proto.v1.AreaPresetSelection"> & {
  /**
   * canonical 英語名 -> preset ULID または "__ALL__"
   *
   * @generated from field: map<string, string> base_areas = 1;
   */
  baseAreas: { [key: string]: string };

  /**
   * sub_areas index（文字列）-> preset ULID または "__ALL__"
   *
   * @generated from field: map<string, string> custom_areas = 2;
   */
  customAreas: { [key: string]: string };
};

/**
 * Describes the message api_proto.v1.AreaPresetSelection.
 * Use `create(AreaPresetSelectionSchema)` to create a new message.
 */
export const AreaPresetSelectionSchema: GenMessage<AreaPresetSelection> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 8);

/**
 * 企業の使用可能な色一覧（カラーシミュレーション表示用）
 *
 * @generated from message api_proto.v1.ListCompanyColorsRequest
 */
export type ListCompanyColorsRequest = Message<"api_proto.v1.ListCompanyColorsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListCompanyColorsRequest.
 * Use `create(ListCompanyColorsRequestSchema)` to create a new message.
 */
export const ListCompanyColorsRequestSchema: GenMessage<ListCompanyColorsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 9);

/**
 * @generated from message api_proto.v1.ListCompanyColorsResponse
 */
export type ListCompanyColorsResponse = Message<"api_proto.v1.ListCompanyColorsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CompanyColorEntry colors = 1;
   */
  colors: CompanyColorEntry[];
};

/**
 * Describes the message api_proto.v1.ListCompanyColorsResponse.
 * Use `create(ListCompanyColorsResponseSchema)` to create a new message.
 */
export const ListCompanyColorsResponseSchema: GenMessage<ListCompanyColorsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 10);

/**
 * 共有リンク経由で施主が見える色一覧（エリア別に解決済み）
 *
 * @generated from message api_proto.v1.ListSharedCompanyColorsRequest
 */
export type ListSharedCompanyColorsRequest = Message<"api_proto.v1.ListSharedCompanyColorsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListSharedCompanyColorsRequest.
 * Use `create(ListSharedCompanyColorsRequestSchema)` to create a new message.
 */
export const ListSharedCompanyColorsRequestSchema: GenMessage<ListSharedCompanyColorsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 11);

/**
 * @generated from message api_proto.v1.ListSharedCompanyColorsResponse
 */
export type ListSharedCompanyColorsResponse = Message<"api_proto.v1.ListSharedCompanyColorsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.SharedAreaColors areas = 1;
   */
  areas: SharedAreaColors[];

  /**
   * カット単位の編集可能エリア。フロントは表示中カットの base_image_id で引く。
   *
   * @generated from field: repeated api_proto.v1.SharedCutAreaScope cuts = 2;
   */
  cuts: SharedCutAreaScope[];
};

/**
 * Describes the message api_proto.v1.ListSharedCompanyColorsResponse.
 * Use `create(ListSharedCompanyColorsResponseSchema)` to create a new message.
 */
export const ListSharedCompanyColorsResponseSchema: GenMessage<ListSharedCompanyColorsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 12);

/**
 * 企業プリセット一覧を取得する
 *
 * @generated from message api_proto.v1.ListAiColorPresetsRequest
 */
export type ListAiColorPresetsRequest = Message<"api_proto.v1.ListAiColorPresetsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListAiColorPresetsRequest.
 * Use `create(ListAiColorPresetsRequestSchema)` to create a new message.
 */
export const ListAiColorPresetsRequestSchema: GenMessage<ListAiColorPresetsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 13);

/**
 * @generated from message api_proto.v1.ListAiColorPresetsResponse
 */
export type ListAiColorPresetsResponse = Message<"api_proto.v1.ListAiColorPresetsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.AiColorPreset presets = 1;
   */
  presets: AiColorPreset[];
};

/**
 * Describes the message api_proto.v1.ListAiColorPresetsResponse.
 * Use `create(ListAiColorPresetsResponseSchema)` to create a new message.
 */
export const ListAiColorPresetsResponseSchema: GenMessage<ListAiColorPresetsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 14);

/**
 * 企業プリセットを作成する
 *
 * @generated from message api_proto.v1.CreateAiColorPresetRequest
 */
export type CreateAiColorPresetRequest = Message<"api_proto.v1.CreateAiColorPresetRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 順序付き色一覧
   *
   * @generated from field: repeated api_proto.v1.AiColorPresetColor colors = 2;
   */
  colors: AiColorPresetColor[];
};

/**
 * Describes the message api_proto.v1.CreateAiColorPresetRequest.
 * Use `create(CreateAiColorPresetRequestSchema)` to create a new message.
 */
export const CreateAiColorPresetRequestSchema: GenMessage<CreateAiColorPresetRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 15);

/**
 * @generated from message api_proto.v1.CreateAiColorPresetResponse
 */
export type CreateAiColorPresetResponse = Message<"api_proto.v1.CreateAiColorPresetResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorPreset preset = 1;
   */
  preset?: AiColorPreset;
};

/**
 * Describes the message api_proto.v1.CreateAiColorPresetResponse.
 * Use `create(CreateAiColorPresetResponseSchema)` to create a new message.
 */
export const CreateAiColorPresetResponseSchema: GenMessage<CreateAiColorPresetResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 16);

/**
 * 企業プリセットを更新する（colors は順序付き全置換）
 *
 * @generated from message api_proto.v1.UpdateAiColorPresetRequest
 */
export type UpdateAiColorPresetRequest = Message<"api_proto.v1.UpdateAiColorPresetRequest"> & {
  /**
   * ai_color_presets.id (ULID)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 順序付き全置換
   *
   * @generated from field: repeated api_proto.v1.AiColorPresetColor colors = 3;
   */
  colors: AiColorPresetColor[];
};

/**
 * Describes the message api_proto.v1.UpdateAiColorPresetRequest.
 * Use `create(UpdateAiColorPresetRequestSchema)` to create a new message.
 */
export const UpdateAiColorPresetRequestSchema: GenMessage<UpdateAiColorPresetRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 17);

/**
 * @generated from message api_proto.v1.UpdateAiColorPresetResponse
 */
export type UpdateAiColorPresetResponse = Message<"api_proto.v1.UpdateAiColorPresetResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorPreset preset = 1;
   */
  preset?: AiColorPreset;
};

/**
 * Describes the message api_proto.v1.UpdateAiColorPresetResponse.
 * Use `create(UpdateAiColorPresetResponseSchema)` to create a new message.
 */
export const UpdateAiColorPresetResponseSchema: GenMessage<UpdateAiColorPresetResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 18);

/**
 * 企業プリセットを削除する（デフォルト指定中は FailedPrecondition）
 *
 * @generated from message api_proto.v1.DeleteAiColorPresetRequest
 */
export type DeleteAiColorPresetRequest = Message<"api_proto.v1.DeleteAiColorPresetRequest"> & {
  /**
   * ai_color_presets.id (ULID)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.DeleteAiColorPresetRequest.
 * Use `create(DeleteAiColorPresetRequestSchema)` to create a new message.
 */
export const DeleteAiColorPresetRequestSchema: GenMessage<DeleteAiColorPresetRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 19);

/**
 * @generated from message api_proto.v1.DeleteAiColorPresetResponse
 */
export type DeleteAiColorPresetResponse = Message<"api_proto.v1.DeleteAiColorPresetResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteAiColorPresetResponse.
 * Use `create(DeleteAiColorPresetResponseSchema)` to create a new message.
 */
export const DeleteAiColorPresetResponseSchema: GenMessage<DeleteAiColorPresetResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 20);

/**
 * ベースエリアのデフォルトプリセット設定を取得する
 *
 * @generated from message api_proto.v1.GetBaseAreaPresetDefaultsRequest
 */
export type GetBaseAreaPresetDefaultsRequest = Message<"api_proto.v1.GetBaseAreaPresetDefaultsRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetBaseAreaPresetDefaultsRequest.
 * Use `create(GetBaseAreaPresetDefaultsRequestSchema)` to create a new message.
 */
export const GetBaseAreaPresetDefaultsRequestSchema: GenMessage<GetBaseAreaPresetDefaultsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 21);

/**
 * @generated from message api_proto.v1.GetBaseAreaPresetDefaultsResponse
 */
export type GetBaseAreaPresetDefaultsResponse = Message<"api_proto.v1.GetBaseAreaPresetDefaultsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.BaseAreaPresetDefault defaults = 1;
   */
  defaults: BaseAreaPresetDefault[];
};

/**
 * Describes the message api_proto.v1.GetBaseAreaPresetDefaultsResponse.
 * Use `create(GetBaseAreaPresetDefaultsResponseSchema)` to create a new message.
 */
export const GetBaseAreaPresetDefaultsResponseSchema: GenMessage<GetBaseAreaPresetDefaultsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 22);

/**
 * ベースエリアのデフォルトプリセットをエリア単位で upsert する
 *
 * @generated from message api_proto.v1.SetBaseAreaPresetDefaultRequest
 */
export type SetBaseAreaPresetDefaultRequest = Message<"api_proto.v1.SetBaseAreaPresetDefaultRequest"> & {
  /**
   * canonical 英語名
   *
   * @generated from field: string base_area = 1;
   */
  baseArea: string;

  /**
   * ai_color_presets.id (ULID)
   *
   * @generated from field: string preset_id = 2;
   */
  presetId: string;
};

/**
 * Describes the message api_proto.v1.SetBaseAreaPresetDefaultRequest.
 * Use `create(SetBaseAreaPresetDefaultRequestSchema)` to create a new message.
 */
export const SetBaseAreaPresetDefaultRequestSchema: GenMessage<SetBaseAreaPresetDefaultRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 23);

/**
 * @generated from message api_proto.v1.SetBaseAreaPresetDefaultResponse
 */
export type SetBaseAreaPresetDefaultResponse = Message<"api_proto.v1.SetBaseAreaPresetDefaultResponse"> & {
};

/**
 * Describes the message api_proto.v1.SetBaseAreaPresetDefaultResponse.
 * Use `create(SetBaseAreaPresetDefaultResponseSchema)` to create a new message.
 */
export const SetBaseAreaPresetDefaultResponseSchema: GenMessage<SetBaseAreaPresetDefaultResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 24);

/**
 * 新着色（過去7日以内に登録された色）の件数を取得する（通知表示用）
 *
 * @generated from message api_proto.v1.CountNewColorsRequest
 */
export type CountNewColorsRequest = Message<"api_proto.v1.CountNewColorsRequest"> & {
};

/**
 * Describes the message api_proto.v1.CountNewColorsRequest.
 * Use `create(CountNewColorsRequestSchema)` to create a new message.
 */
export const CountNewColorsRequestSchema: GenMessage<CountNewColorsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 25);

/**
 * @generated from message api_proto.v1.CountNewColorsResponse
 */
export type CountNewColorsResponse = Message<"api_proto.v1.CountNewColorsResponse"> & {
  /**
   * @generated from field: int64 count = 1;
   */
  count: bigint;
};

/**
 * Describes the message api_proto.v1.CountNewColorsResponse.
 * Use `create(CountNewColorsResponseSchema)` to create a new message.
 */
export const CountNewColorsResponseSchema: GenMessage<CountNewColorsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_color, 26);

/**
 * カラートーン（色のグループ分け）。UI のトーン絞り込みチップと 1:1 で対応する。
 *
 * DB (`colors.tone`) は VARCHAR で日本語ラベル（例: "グレー系"）を保持しており、
 * enum ↔ ラベルの相互変換は Go 側 `go/models/color_tone.go` を SSOT とする。
 * MySQL の ENUM 型は値追加が ALTER を伴うため DB では採用していない。
 *
 * 値の並びは UI のチップ表示順と一致させている。
 *
 * @generated from enum api_proto.v1.ColorTone
 */
export enum ColorTone {
  /**
   * 未指定。絞り込み条件としては「全トーン」を意味する
   *
   * @generated from enum value: COLOR_TONE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ホワイト系
   *
   * @generated from enum value: COLOR_TONE_WHITE = 1;
   */
  WHITE = 1,

  /**
   * グレー系
   *
   * @generated from enum value: COLOR_TONE_GRAY = 2;
   */
  GRAY = 2,

  /**
   * ベージュ系
   *
   * @generated from enum value: COLOR_TONE_BEIGE = 3;
   */
  BEIGE = 3,

  /**
   * ブラウン系
   *
   * @generated from enum value: COLOR_TONE_BROWN = 4;
   */
  BROWN = 4,

  /**
   * ブラック系
   *
   * @generated from enum value: COLOR_TONE_BLACK = 5;
   */
  BLACK = 5,

  /**
   * レッド系
   *
   * @generated from enum value: COLOR_TONE_RED = 6;
   */
  RED = 6,

  /**
   * オレンジ系
   *
   * @generated from enum value: COLOR_TONE_ORANGE = 7;
   */
  ORANGE = 7,

  /**
   * イエロー系
   *
   * @generated from enum value: COLOR_TONE_YELLOW = 8;
   */
  YELLOW = 8,

  /**
   * グリーン系
   *
   * @generated from enum value: COLOR_TONE_GREEN = 9;
   */
  GREEN = 9,

  /**
   * ブルー系
   *
   * @generated from enum value: COLOR_TONE_BLUE = 10;
   */
  BLUE = 10,

  /**
   * パープル系
   *
   * @generated from enum value: COLOR_TONE_PURPLE = 11;
   */
  PURPLE = 11,

  /**
   * ピンク系
   *
   * @generated from enum value: COLOR_TONE_PINK = 12;
   */
  PINK = 12,
}

/**
 * Describes the enum api_proto.v1.ColorTone.
 */
export const ColorToneSchema: GenEnum<ColorTone> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_color, 0);

